import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import { Currency } from '@sequencehq/api'

export enum MinimumEditorMode {
  VIEW = 'view',
  EDIT = 'edit',
  CREATE = 'create'
}

type ApiPrice = DashboardApi20240730.GetPrice.Price
export type MinimumScopeTarget = 'allUsage' | 'specific'
export type MinimumScope = {
  target: MinimumScopeTarget
  priceIds: MinimumEditorPrice['id'][]
}

export type Minimum = {
  id: string
  value: string
  name: string
  scope: MinimumScope
}

export type MinimumEditorPrice = Omit<
  ApiPrice,
  | 'sequenceAccountId'
  | 'updatedAt'
  | 'createdAt'
  | 'integrationIds'
  | 'customMetricParameters'
  | 'productId'
> & {
  productId?: string
}

export type MinimumEditorRootProps = {
  existingMinimum: Minimum | null
  applyToAllAvailable: boolean
  availablePrices: MinimumEditorPrice[]
  mode: MinimumEditorMode
  currency: Currency
  onClose: () => void
  onSave: (updatedMinimum: Minimum) => void
}
